<template>
   
   <div style="width:100%;height:100%" ref="schedbox">
    <app-section-loader :status="loader"></app-section-loader>

	  <v-snackbar :top="true"  v-model="snackbar">
			{{ snackbarMessage }}
		</v-snackbar>

 <div id="scheduler">
    <dx-scheduler  ref="myScheduler"
      :data-source="getAppointments"
      :groups="groups"
      :group-by-date="false"
      :current-date="currentDate"
      :height="getHeightScheduler"
      :start-day-hour="7"
      :end-day-hour="22"
	  :firstDayOfWeek="1"
	  :views="views"
      :cross-scrolling-enabled="false"
	  :cellDuration="15"
	  :onOptionChanged = "onOptionChanged"
	  appointmentTemplate = "appTemplate"
	  appointmentTooltipTemplate = ""
	  :dataCellTemplate = "dataCellTemplate"
      current-view="day"
	  :showAllDayPanel="false"
	  :onAppointmentUpdating = "appointmentUpdating"
	  :onAppointmentDeleting = "appointmentDeleting"
	  :onAppointmentClick = "onAppointmentClick"
	  :onAppointmentDblClick = "onAppointmentDblClick"
	  :onCellClick = "onCellClick"
    >

	 <!--appointmentTooltipTemplate = "appointmentTooltipTemplate"-->

		<dx-editing 
        :allow-adding = "canUpdate"
        :allow-deleting = "canUpdate"
        :allow-updating = "canUpdate"
		:allow-dragging = "canUpdate"
        :allow-resizing = "canUpdate"
      	/>
	
	   
	  
      <dx-resource
        :allow-multiple="false"
        :data-source="dataSourceResource"
        field-expr="userId"
        label="UserID"
      />

	<div slot="appointmentTooltipTemplate" slot-scope="data">
		<div style="height:100%;color:#000000">
		<span v-if="data.itemobject.KindAppoint == 10005">
			{{data.itemobject.UserName}}<br>
			{{data.itemobject.Message}}
		</span>
		<span v-else>
			{{data.itemobject.UserName}}<br>
			<strong> {{data.itemobject.Customer.FirstName}}  {{data.itemobject.Customer.LastName}}</strong><br>
			{{data.itemobject.ArticleDescr}}
		</span>
	
		</div>
  	</div>
	
	<div slot="appTemplate" slot-scope="data" v-bind:style="{ 'background-color': data.color}">
		<div style="height:100%;color:#eeeeee"  v-bind:style="{ 'background-color': data.color}">
		<span v-if="data.itemobject.KindAppoint == 10005">
			{{data.itemobject.UserName}}<br>
			{{data.itemobject.Message}}
			<span style="position: absolute;bottom: 0;right: 0;">&nbsp;
				<span style="padding: 2px;" v-if="data.itemobject.RecurrenceID != '00000000-0000-0000-0000-000000000000'"><img src="/static/img/appoint/recurrence-16.png" /></span>
			</span>
		</span>
		<span v-else>
			{{data.itemobject.UserName}}<br>
			<strong> {{data.itemobject.Customer.FirstName}}  {{data.itemobject.Customer.LastName}}</strong><br>
			{{data.itemobject.ArticleDescr}}
			{{data.itemobject.Message}}
			<span style="position: absolute;bottom: 0;right: 0;">&nbsp;
				<span style="padding: 2px;"  v-if="data.itemobject.RecurrenceID != '00000000-0000-0000-0000-000000000000'"><img src="/static/img/appoint/recurrence-16.png" /></span>
				<span style="padding: 2px;" v-if="data.itemobject.IsCustomerChoiseUser === 1"><img src="/static/img/appoint/userico-16.png" /></span>
				<span style="padding: 2px;" v-if="data.itemobject.IsWebAppoint  === 1"><img src="/static/img/appoint/www-16-white.png" /></span>
				<span style="padding: 2px;" v-if="data.itemobject.IsBirthDay  === 1"><img src="/static/img/appoint/birthday-16.png" /></span>
			</span>
		</span>

		</div>
  	</div>


    </dx-scheduler>

  </div>

	<AppointForm  ref="appForm"></AppointForm>
	 
	</div>
</template>
 
<script>
	import { DxScheduler, DxResource, DxView, DxEditing } from 'devextreme-vue/scheduler';
	//import { DxPopup } from 'devextreme-vue/ui/popup';

	import AppointForm from "../../components/Appointment/AppointForm";

	import ArrayStore from "devextreme/data/array_store";
	import myHttpApi from "../../api/myHttpApi";
	import Vue from 'vue'
	import moment from 'moment'

	import devXtremeLang from "devextreme-intl";
	import nlMessages from "devextreme/localization/messages/nl.json";
	import { locale, loadMessages } from "devextreme/localization";

    export default {
        components: {
            DxScheduler,
			DxResource,
			DxEditing,
			DxView,
			locale,
			loadMessages,
			AppointForm
        },
        data: function () {
            return {
				loader: true,
				arrAppointments : [],
				arrUsers : [],
				groupByDate: true,
				groups: ['userId'],
				currentDate: new Date(),
				dataSource: [],
				dataSourceResource : [],
				views: ['day', 'week'],
				heightSched : 600,
				kindview : 'day',
				snackbarMessage: "",
				snackbar: false,
				canUpdate : false,
				showAppWindow : false
            }
        },
        computed:{
			getHeightScheduler: function () {
				return this.heightSched;
			},
			onAllowChange : function () {
				return true;
			},
			getAppointments : function () {
				return this.dataSource;
			}
		},
        mounted: function () {
			
			loadMessages (nlMessages);
			locale ('nl');
			
			this.heightSched = this.$refs.schedbox.clientHeight;
			this.dataSource = [];
			this.dataSourceResource = [];
			this.loadUsers ();
			
		},
		methods: {
			
			onOptionChanged (item) {

				if (item.name == 'currentView')
				{
					this.kindview = item.value;
					this.loadAppointments ();
				}
				if (item.name == 'currentDate')
				{
					this.currentDate = item.value;
					
					this.loadAppointments ();
					
				}
			},
			onCellClick (item) {
				
				this.$refs.appForm.show();
			},
			onAppointmentClick (item) {
				
				this.$refs.appForm.show(item);
			},
			onAppointmentDblClick (item) {
				item.cancel = true;
				//this.showAppWindow = true;
				this.$refs.appForm.show();
			},
			appointmentUpdating (item) {
				return;
			},
			appointmentDeleting (item) {
				return;
			},
			dataCellTemplate (itemData, itemIndex, itemElement) {
		
				var htmlNoWork = "<div style='background-color:#555;width:100%;height:100%;'></div>";
				if (itemData.groups == undefined) return ("");
				
				if (this.isWorkingTime (itemData.startDate, itemData.endDate, itemData.groups.userId))
				{
					return ("");
				}
				
				return (htmlNoWork);
			},
			buidArrayUserHoursWeek () {
				//In weekoverzicht  verberg uren
				for (var c = 0; c < this.arrUsers.length; c++)
				{
					var uRec = [];
					for (var d = 0; d < (12 * 24); d++)	//5min cell
					{
						uRec[d] = 1;
					}
					this.arrUsers[c].TimeTable = uRec;
				}
				
			},
			buidArrayUserHours (start) {
				for (var c = 0; c < this.arrUsers.length; c++)
				{
					var uRec = [];
					for (var d = 0; d < (12 * 24); d++)	//5min cell
					{
						uRec[d] = 0;
					}

					//Gewone werkuren
					var hours = this.arrUsers[c].UserHours;
					if (hours == undefined) continue;

					for (var e = 0; e < hours.length; e++)
					{
						var wd = hours[e];
						var isValidHour = true;

						if ((start.getDay() == 0) && (!wd.IsSun)) isValidHour = false;
						if ((start.getDay() == 1) && (!wd.IsMon)) isValidHour = false;
						if ((start.getDay() == 2) && (!wd.IsTue)) isValidHour = false;
						if ((start.getDay() == 3) && (!wd.IsWed)) isValidHour = false;
						if ((start.getDay() == 4) && (!wd.IsThu)) isValidHour = false;
						if ((start.getDay() == 5) && (!wd.IsFri)) isValidHour = false;
						if ((start.getDay() == 6) && (!wd.IsSat)) isValidHour = false;

						if (isValidHour)
						{
							var dStart = new Date (moment (wd.DatFrom)); // new Date (wd.DatFrom);
							var dEnd =  new Date (moment (wd.DatTo)); // new Date (wd.DatTo);
							console.log (dStart + " " + dEnd);
							var totMinStart = (dStart.getHours() * 60) + dStart.getMinutes();
							var totMinEnd = (dEnd.getHours() * 60) + dEnd.getMinutes();
							for (var d = 0; d < (12 * 24); d++)	//5min cell (60 / 12)
							{
								var totMin = d * 5;
								if ((totMin >= totMinStart) && (totMin < totMinEnd))
								{
									uRec[d] = 1;
								}
							}
						}
					}
					this.arrUsers[c].TimeTable = uRec;
				}
				this.buidArrayExceptHours (start);
			},
			buidArrayExceptHours (dtReg) {
				
				var start = new Date (dtReg.getFullYear(), dtReg.getMonth(), dtReg.getDate());

				for (var c = 0; c < this.arrUsers.length; c++)
				{
					//Gewone werkuren
					var hours = this.arrUsers[c].ExceptHours;
					if (hours == undefined) continue;

					for (var e = 0; e < hours.length; e++)
					{
						var wd = hours[e];
						var isValidHour = false;

						//console.log (wd);

						if ((start.getDay() == 0) && (wd.IsSun)) isValidHour = true;
						if ((start.getDay() == 1) && (wd.IsMon)) isValidHour = true;
						if ((start.getDay() == 2) && (wd.IsTue)) isValidHour = true;
						if ((start.getDay() == 3) && (wd.IsWed)) isValidHour = true;
						if ((start.getDay() == 4) && (wd.IsThu)) isValidHour = true;
						if ((start.getDay() == 5) && (wd.IsFri)) isValidHour = true;
						if ((start.getDay() == 6) && (wd.IsSat)) isValidHour = true;

						//var dStart = new Date (wd.DatFrom);
						//var dEnd =  new Date (wd.DatTo);

						var dStart = new Date (moment (wd.DatFrom)); // new Date (wd.DatFrom);
						var dEnd =  new Date (moment (wd.DatTo)); // new Date (wd.DatTo);

						if (start.getTime() > dEnd.getTime()) isValidHour = false;

						if (isValidHour)
						{
							
							var totMinStart = (dStart.getHours() * 60) + dStart.getMinutes();
							var totMinEnd = (dEnd.getHours() * 60) + dEnd.getMinutes();
							for (var d = 0; d < (12 * 24); d++)	//5min cell (60 / 12)
							{
								var totMin = d * 5;
								if ((totMin >= totMinStart) && (totMin < totMinEnd))
								{
									if (wd.KindID == 1) this.arrUsers[c].TimeTable[d] = 0;  //Afwezig
									if (wd.KindID == 2) this.arrUsers[c].TimeTable[d] = 1;  //Aanwezig
									if (wd.KindID == 10) this.arrUsers[c].TimeTable[d] = 1;
									if (wd.KindID == 11) this.arrUsers[c].TimeTable[d] = 0;
									
								}
							}
						}
					}
				}
			},
			isWorkingTime (start, end, userId){	
				for (var c = 0; c < this.arrUsers.length; c++)
				{
					if (this.arrUsers[c].UserID == userId)
					{
						if (this.arrUsers[c].TimeTable == undefined) continue;

						var totMinStart = (start.getHours() * 60) + start.getMinutes();
						totMinStart = totMinStart / 5;
						return (this.arrUsers[c].TimeTable[totMinStart]);
					}
				}
				return false;
			},
			getMonday(d) {
				d = new Date(d);
				var day = d.getDay(),
				diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
				return new Date(d.setDate(diff));
			},
			createAppointment (item){
				var app= item.itemobject;
				app.DatStart = item.startDate;
				app.UserID = item.userId;
				var start = moment (item.startDate);
				var end  = moment (item.endDate);
				var minutes = end.diff (start, 'minutes');
				app.MinutesDuration = minutes;
				return app;
			},
			loadAppointments () {
				myHttpApi

				this.heightSched = this.$refs.schedbox.clientHeight;

				this.loader = true;
				this.arrAppointments = [];
				var start = new Date (this.currentDate);
				var	end = new Date (start);

				if (this.kindview == "week")
				{
					this.buidArrayUserHoursWeek ();
					start = this.getMonday (start);
					end.setDate (end.getDate() + 7);
				}
				else
				{
					this.buidArrayUserHours (start);
				}
				
				
				var from = moment(start).format ("YYYY-MM-DD 00:00:00");
				var to =  moment(end).format ("YYYY-MM-DD 23:59:00");
				const searchRec = {From: from, To: to}
				myHttpApi.post( 'BOAppointment/Search', searchRec)
				.then(response => {
							this.loader = false;
							this.arrAppointments = [];
							this.arrAppointments = response.data;
							this.dataSource =  [];

							for (var c = 0; c < this.arrAppointments.length; c++)
							{
								var app = this.getAppointRec(this.arrAppointments[c]);
								this.dataSource.push (app);
								if (app.user2Id != '00000000-0000-0000-0000-000000000000')
								{
									var appRoom = this.getAppointRec(this.arrAppointments[c]);
									appRoom.userId = appRoom.user2Id;
									appRoom.isRoom = true;
									this.dataSource.push (appRoom);
								}
							}
							this.loader = false;							
				})
				.catch(error => {
					this.arrAppointments = [];
					this.dataSource =  [];
					this.loader = false;
					return null;
				});
			},
			loadUsers () {
				myHttpApi
				
				this.loader = true;

				this.arrUsers = [];
				const searchRec = {Search: '', Extra: ''}
				myHttpApi.post( 'BOAppointment/Users', searchRec)
				.then(response => {
							this.loader = false;
							this.arrUsers = [];
							this.arrUsers = response.data;
							this.dataSourceResource = [];
							for (var c = 0; c < this.arrUsers.length; c++)
							{
								if (!this.arrUsers[c].IsHideScheduler)
								{
									this.dataSourceResource.push (this.getResourceRec(this.arrUsers[c]));
								}
							}

							if (this.arrUsers.length == 1)
							{
								if (this.arrUsers[0].ApplicationRightsJson == "OWN")
								{
									this.canUpdate = false;
									this.views  =  ['day'];
								}
								
							}

							this.loadAppointments ();
							
				})
				.catch(error => {
					this.dataSourceResource = [];
					this.loader = false;
				});
			},
			getAppointRec (item)
			{
				var appointment1 = {
					id: item.AppointmentID,
					startDate: item.DatStart,
					endDate: item.DatEnd,
					userId: item.UserID,
					user2Id : item.RoomID,
					isRoom : false,
					color: item.ColorStr,
					editing : true,
					itemobject : item 
				}
				appointment1.itemobject.IsBirthDay = 0;
				var mStart = moment (item.DatStart).format ("MM-DD");
				var mBirth = moment (appointment1.itemobject.Customer.DatBirth).format ("MM-DD");
				if (mStart == mBirth) appointment1.itemobject.IsBirthDay = 1;
				return appointment1;
			},
			getResourceRec (item)
			{
				var res = {
					text: item.UserName,
					id: item.UserID
				}
				return res;
			},
           
		}
    }
</script>
<style scoped>
.cellNonWorking {
	background-color : #111111;
}

.options {
    padding: 20px;
    background-color: rgba(191, 191, 191, 0.15);
    margin-top: 20px;
}

.caption {
    font-size: 18px;
    font-weight: 500;
}

.option {
    margin-top: 10px;
    display: inline-block;
}

.dx-scheduler-work-space-group-by-date .dx-scheduler-group-header-content {
    font-size: 11px;
}
.dx-scheduler-appointment
{
	background-color:#f00;
}
</style>